
<!-- theme [styleObj]='brandStyleTheme' -->
<nav>

    <!-- <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="space-around center" fxLayoutGap="25px">
        <mat-card fxFlex="calc(33%-25px)" fxFlex.sm="calc(50%-25px)" > -->
            <img [src]="brandLogoImage" alt=""/>
            <!-- <span *ngIf="isHeaderTitleShown">{{headerTitle}}</span> -->
            <h5>{{headerSubtitle}}</h5>

            <!-- <mat-card-header>
            <div mat-card-avatar class="avatar-header-image" *ngIf="isHeaderAvatarShown"></div>
            <mat-card-title *ngIf="isHeaderTitleShown"><h3>{{headerTitle}}</h3></mat-card-title>
            <mat-card-subtitle *ngIf="isHeaderSubtitleShown"><h4>{{headerSubtitle}}</h4></mat-card-subtitle>
          </mat-card-header> -->
          <!-- <mat-card-content>
            <p>
              {{member.content}}
            </p>
          </mat-card-content> -->
        <!-- </mat-card>
      </div> -->

<!--
    <div class="row">
        <div class="col-12">
            <div *ngIf="isBrandLogoImageShown">
                <img class="img-responsive mx-auto d-block"  [src]="brandLogoImage">
            </div>
        </div>
    </div>
     -->

     <span class="example-spacer" ></span>
     <!-- <span class="head-menu"></span> -->
    <div class="row">

    <div *ngIf="isLogoutVisible">
        <input type="button" class="dsb-exit-button" (click)="signout()" value="Logout"/>
    </div>

    <div *ngIf="!isLogoutVisible">
      <span>
        <h5 class="text-center env-banner">{{environmentBanner}}</h5>
      </span>
    </div>

    </div>

</nav>

